import { call, put, take, select } from 'redux-saga/effects'
import api from '../api/api'

import { isResponseSuccessful } from '../helpers/utility'
import {
  FETCH_USER_BALANCE_REQUEST,
  FETCH_USER_BALANCE_SUCCESS,
  FETCH_USER_BALANCE_FAIL,
  FETCH_USER_BALANCE_ASYNC_START,
  FETCH_USER_BALANCE_ASYNC_END,
} from '../actions/actions'
import {
  REQUEST_PAYMENT_REQUEST,
  REQUEST_PAYMENT_SUCCESS,
  REQUEST_PAYMENT_FAIL,
  REQUEST_PAYMENT_ASYNC_START,
  REQUEST_PAYMENT_ASYNC_END,
} from '../actions/actions'
import {
  CONFIRM_PAYMENT_REQUEST,
  CONFIRM_PAYMENT_SUCCESS,
  CONFIRM_PAYMENT_FAIL,
  CONFIRM_PAYMENT_ASYNC_START,
  CONFIRM_PAYMENT_ASYNC_END,
} from '../actions/actions'

export function* fetchUserBalance() {
  while (true) {
    yield take(FETCH_USER_BALANCE_REQUEST)
    yield put({ type: FETCH_USER_BALANCE_ASYNC_START })
    const userId = yield select(state => state.auth.userId)

    try {
      const {
        data: {
          data,
          status,
          errors: { general_errors, form_errors },
        },
      } = yield call(api.getUserBalance, userId)

      if (isResponseSuccessful(status, form_errors, general_errors)) {
        yield put({
          type: FETCH_USER_BALANCE_SUCCESS,
          balance: data.user.balance,
          coins: data.user.coins,
        })
      } else {
        yield put({
          type: FETCH_USER_BALANCE_FAIL,
          form_errors,
          general_errors,
        })
      }

      yield put({ type: FETCH_USER_BALANCE_ASYNC_END })
    } catch (error) {
      console.log(error)
      yield put({ type: FETCH_USER_BALANCE_FAIL, error })
      yield put({ type: FETCH_USER_BALANCE_ASYNC_END })
    }
  }
}

export function* requestPayment() {
  while (true) {
    const { formData, resolve, reject } = yield take(REQUEST_PAYMENT_REQUEST)
    yield put({ type: REQUEST_PAYMENT_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.requestPayment, formData)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: REQUEST_PAYMENT_SUCCESS,
          data,
        })

        resolve(data)
      } else {
        yield put({
          type: REQUEST_PAYMENT_FAIL,
          errors,
        })

        reject(errors)
      }

      yield put({ type: REQUEST_PAYMENT_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: REQUEST_PAYMENT_FAIL, error })
      yield put({ type: REQUEST_PAYMENT_ASYNC_END })
      console.log(error)
    }
  }
}

export function* confirmRecharge() {
  while (true) {
    const { formData, resolve, reject } = yield take(CONFIRM_PAYMENT_REQUEST)
    yield put({ type: CONFIRM_PAYMENT_ASYNC_START })

    try {
      const {
        data: { data, status, errors },
      } = yield call(api.confirmRecharge, formData)

      if (isResponseSuccessful(status, errors.form_errors, errors.general_errors)) {
        yield put({
          type: CONFIRM_PAYMENT_SUCCESS,
          data,
        })

        resolve(data)
      } else {
        yield put({
          type: CONFIRM_PAYMENT_FAIL,
          errors,
        })

        reject(errors)
      }

      yield put({ type: CONFIRM_PAYMENT_ASYNC_END })
    } catch (error) {
      reject()
      yield put({ type: CONFIRM_PAYMENT_FAIL, error })
      yield put({ type: CONFIRM_PAYMENT_ASYNC_END })
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/creditSaga.js